/* eslint-disable */
import { Middleware } from "@sa/rep-common";
import { DataFlowProcessingState } from "@sa/rep-core";
import { ServiceProvider } from "@sa/rep-services-provider";

export const slide24DataflowMiddlewares = (serviceProvider: ServiceProvider) => {
  return (async function (input, next) {
    return next(input);
  }) as Middleware<DataFlowProcessingState>
};  
